import {
  DeferredType,
  type CopilotReviewerRow,
  type PendingReviewRequest,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import {ShieldIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {clsx} from 'clsx'
import {copilotReviewStatusText} from '../copilot-review-effort'
import {codeOwnerTooltip, deferredTooltip} from '../review-state-helpers'
import styles from '../Reviewers.module.css'
import {ReviewerIdentity, reviewerDisplayName} from '../ReviewerIdentity'
import {DeferredStatusIcon, ReviewStatusDetails, ReviewStatusIndicator} from '../ReviewStatusIcons'

export function PendingReviewRow({
  request,
  copilotReviewerRow,
  lastCompletedCopilotReviewEffort,
}: {
  request: PendingReviewRequest
  copilotReviewerRow?: CopilotReviewerRow
  lastCompletedCopilotReviewEffort?: number
}) {
  const reviewer = request.reviewer
  if (!reviewer) return null

  const name = reviewerDisplayName(reviewer)
  const activeCopilotRequest = copilotReviewerRow !== undefined && request.deferredType === DeferredType.UNSPECIFIED
  const inProgressLabel = activeCopilotRequest
    ? copilotReviewStatusText({
        row: copilotReviewerRow,
        requestedCopilotReviewEffort: request.requestedCopilotReviewEffort,
        lastCompletedCopilotReviewEffort,
      })
    : undefined
  const deferredLabel =
    request.deferredType !== DeferredType.UNSPECIFIED ? deferredTooltip(request.deferredType, name) : undefined
  const pendingLabel =
    request.deferredType !== DeferredType.COPILOT
      ? (inProgressLabel ?? `Awaiting requested review from ${name}`)
      : undefined

  return (
    <li className={styles.reviewerRow}>
      <ReviewStatusDetails label={[deferredLabel, pendingLabel].filter(Boolean).join('. ')}>
        <ReviewerIdentity reviewer={reviewer} />
      </ReviewStatusDetails>
      <span className={styles.indicators}>
        {deferredLabel && <DeferredStatusIcon label={deferredLabel} />}
        {request.isCodeOwner && !request.isCodeOwnerFromDelegation && (
          <IconButton
            icon={ShieldIcon}
            aria-label={codeOwnerTooltip(request)}
            variant="invisible"
            size="small"
            tooltipDirection="nw"
            className={clsx(styles.statusIcon, 'color-fg-muted')}
          />
        )}
        {pendingLabel && <ReviewStatusIndicator label={pendingLabel} />}
      </span>
    </li>
  )
}
